<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create a Template
          </h2>
        </div>
      </div>
    </div>
    <div class="px-10 py-10 bg-white menucontrol-scroll fixed-top">
      <div>
        <h4 class="text-4f4f4f font-semibold fsize20 mb-0">Pick a Template</h4>
        <p class="text-8f8f8f fsize14">Select a layout for your email</p>
      </div>

      <div class="flex gap-8 mt-8">
        <div
          @click="handleShow(item.route)"
          v-for="(item, index) in layouts"
          :key="'item-' + index"
        >
          <img :src="item.image" alt="templates" class="tempselect-cs" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      layouts: [
        {
          id: "01",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/template1.png",
          route: "marcom-Templatelayout1",
        },
        {
          id: "02",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp2.png",
          route: "marcom-Templatelayout2",
        },
        {
          id: "03",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp3.png",
          route: "marcom-Templatelayout3",
        },
        {
          id: "04",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/master/emailTemplates/temp4.png",
          route: "marcom-Templatelayout4",
        },
      ],
    };
  },
  methods: {
    handleShow(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
>
